import { loginSuccess, setLoading, tokenInvalid, tokenValidated } from '@store/slices/authSlice'
import type { SessionRestoreResult } from '@utils/sessionRestore'

export type SessionRestoreDispatchResult =
  | 'validated'
  | 'refreshed'
  | 'invalid'
  | 'unavailable'

type AuthDispatch = (action: ReturnType<
  | typeof tokenValidated
  | typeof loginSuccess
  | typeof tokenInvalid
  | typeof setLoading
>) => void

/**
 * Maps a session restore API result to Redux auth actions.
 * Extracted for unit testing startup remember-me behavior.
 */
export function applySessionRestoreResult(
  result: SessionRestoreResult,
  dispatch: AuthDispatch,
  options: { rememberMe: boolean; navigateToLogin?: () => void }
): SessionRestoreDispatchResult {
  switch (result.status) {
    case 'validated':
      dispatch(tokenValidated(result.user))
      return 'validated'
    case 'refreshed':
      dispatch(
        loginSuccess({
          user: result.user,
          token: result.accessToken,
          rememberMe: options.rememberMe,
        })
      )
      return 'refreshed'
    case 'invalid':
      dispatch(tokenInvalid())
      return 'invalid'
    case 'unavailable':
      dispatch(setLoading(false))
      return 'unavailable'
  }
}
